const es = {
  login: {
    welcome: 'Bienvenido de nuevo!',
    signinto: 'Acceder a',
    enterdetail: 'Introduzca sus datos de acceso.',
    user: "Correo electrónico",
    requireduser: 'El correo electrónico es obligatorio',
    invaliduser: 'El correo electrónico no es válido',
    password: "Contraseña",
    requiredpassword: 'La contraseña es obligatoria',
    remenberme: 'Recordadme',
    forgotpassword: 'Recuperar contraseña',
    login: 'Acceder' 
  }
};
  
  export default es;
  